import _ from "underscore";

export default {
  toNumber(str) {
    return parseInt(str, 10);
  },

  toObject(key, value, obj = {}) {
    if (key != null) {
      obj[key] = value;
    }
    return obj;
  },

  makeArray(element) {
    if (_.isArray(element)) {
      return element;
    }
    return [element];
  },

  regexEscape(str) {
    if (!str) {
      return;
    }
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
  }, // escape RegExp

  matchesSearchQuery(str, query) {
    return (
      !query ||
      (str != null
        ? str.toLowerCase().match(new RegExp(`\\b${this.regexEscape(query != null ? query.toLowerCase() : undefined)}`))
        : undefined)
    );
  },

  getValueWithinRange(number, min, max) {
    return Math.min(Math.max(min, number), max);
  },

  randomKey(id) {
    let key = Math.round(Math.random() * 100000);
    if (id) {
      key + `_${id}`;
    }
    return key;
  },

  // not use classList.remove b/c IE9
  removeClassname(classNames, toRemove) {
    return classNames.replace(new RegExp(`(?:^|\\s)${`${toRemove}`}(?:\\s|$)`), "");
  },

  pick(obj = {}, arrOfKeys) {
    const arr = !Array.isArray(arrOfKeys) ? this.makeArray(arrOfKeys) : arrOfKeys;
    return arr.reduce((accum, key) => {
      const value = obj[key];
      if (typeof value !== "undefined" && value !== null) {
        accum[key] = value;
        return accum;
      }
      return accum;
    }, {});
  },
  noop() {},
  debounceEvent(callback, time) {
    let interval;
    return (...args) => {
      clearTimeout(interval);
      interval = setTimeout(() => {
        interval = null;
        callback(...args);
      }, time);
    };
  },
};
